
/* Protopia Ecosystem component */
export interface ITopHeaderOverlayProps {
   
}
const TopHeaderOverlay = (props: ITopHeaderOverlayProps): JSX.Element => {
    return <div className='pe-top-header-overlay-container'>
       
    </div>
}
export default TopHeaderOverlay